/**
 * Get token from meta tag in header and add CSRF token to the ajax request
 * @author Rick van der Burg <rick@click.nl>
 */
var prepareForAjax = function() {
    $.ajaxSetup({
        headers:
        {
            'X-CSRF-Token': $('meta[name="_token"]').prop('content')
        }
    });
}

prepareForAjax();


// WEBPACK FOOTER //
// ./resources/assets/js/frontend/components/prepare-for-ajax.js